import { Link } from "react-router-dom";
import { BLOCKING_STATUSES, TODAY } from "../../data/company";
import { daysBetween, driverName, findDriver, findUnit } from "../../lib/company";
import { useCompany } from "../../lib/companyContext";
import { shortDate } from "../../lib/format";
import { Card, CardTitle } from "./ui";
import { useT } from "../../i18n";

/** Pick-ups and returns in the next 14 days. */
export default function UpcomingMovements() {
  const t = useT();
  const m = t.company.overview.movements;
  const { state } = useCompany();
  const within = (date: string) => {
    const d = daysBetween(TODAY, date);
    return d >= 0 && d <= 14;
  };

  const items = state.bookings
    .filter((b) => BLOCKING_STATUSES.includes(b.status))
    .flatMap((b) => {
      if (b.status === "confirmed" && within(b.start)) return [{ kind: m.pickup, date: b.start, b }];
      if (b.status === "active" && within(b.end)) return [{ kind: m.return, date: b.end, b }];
      return [];
    })
    .sort((x, y) => x.date.localeCompare(y.date))
    .slice(0, 6);

  return (
    <Card>
      <CardTitle>{m.title}</CardTitle>
      {items.map(({ kind, date, b }) => (
        <Link
          key={b.id + kind}
          to={`/company/bookings/${b.id}`}
          className="flex justify-between gap-2.5 border-t border-[#F0F0F0] py-2.5 text-[13px] text-ink no-underline"
        >
          {/* Long names wrap; the date keeps its width */}
          <span className="min-w-0 break-words">
            <b className="font-medium">{kind}</b> ·{" "}
            {b.unitId ? findUnit(state, b.unitId)?.code : m.toAssign} ·{" "}
            {driverName(findDriver(state, b.driverId))}
          </span>
          <span className="shrink-0 whitespace-nowrap text-muted">{shortDate(date)}</span>
        </Link>
      ))}
      {items.length === 0 && (
        <p className="m-0 text-[13px] text-faint">{m.empty}</p>
      )}
    </Card>
  );
}
